module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-area"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    ref: "textarea",
    staticClass: "textarea",
    attrs: {
      "rows": "1",
      "placeholder": 'Добавить ' + (typeof this.label != 'undefined' ? this.label : '')
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "blur": _vm.finishEdit,
      "focus": _vm.startEdit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-292a1e79","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditArea.vue
// module id = 1081
// module chunks = 0